module.exports = __webpack_public_path__ + "static/media/promo_band_1b.a15c6d67.jpg";